import { Pipe, PipeTransform, Predicate } from '@angular/core';
import { LoggingService } from '../services/logging';

@Pipe({
    name: 'filterBy',
    standalone: false
})
export class FilterByPipe implements PipeTransform {
    constructor(private log: LoggingService) {}
    transform(values: Array<any>, thisPredicate: string) {
        if (!values) {
            return [];
        }
        this.log.verbose({ type: 'FilterByPipe', thisPredicate, values });
        const pred: Predicate<any> = eval(thisPredicate);
        return values.filter(pred);
    }
}
